import { render, staticRenderFns } from "./join-team-dialog.vue?vue&type=template&id=88a81cac&scoped=true&"
import script from "./join-team-dialog.vue?vue&type=script&lang=js&"
export * from "./join-team-dialog.vue?vue&type=script&lang=js&"
import style0 from "./join-team-dialog.vue?vue&type=style&index=0&id=88a81cac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88a81cac",
  null
  
)

export default component.exports